export const scrollToForm = function (data) {
  if (data) data.$vuetify.goTo("form", { duration: 150, offset: 65, easing: "easeInOutCubic" });
};

export const scrollToElement = function (data, element) {
  if (data) data.$vuetify.goTo(element, { duration: 150, offset: 65, easing: "easeInOutCubic" });
};



// WEBPACK FOOTER //
// ./src/helpers/form-scroll-to.js